function clearCartIfOnlyOneSpecificItem() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const items = cart.items;

      if (items.length === 1 && items[0].handle === 'anson-belt-4-strap-hanger-in-gunmetal-free') {
        fetch('/cart/clear.js', { method: 'POST' })
          .then(() => {
            console.log('Cart cleared: only the specific item was in the cart.');
            $(".drawer").load(document.URL + " #CartDrawer");
          });
      }
      else{
         $(".drawer").load(document.URL + " #CartDrawer");
      }
    })
    .catch(error => console.error('Error checking the cart:', error));
}



async function newHangerAdded(CartItems) {
  const completeBeltProducts = CartItems.filter(
    (item) =>
      item.handle.includes("complete-belts") ||
      item.handle.includes("women-complete-belts")
  );

  // No complete belts found
    if (completeBeltProducts.length === 0)
    {
        const FreeHangerGumatal = CartItems.filter((item) =>item.handle.includes("anson-belt-4-strap-hanger-in-gunmetal-free"));
        if (FreeHangerGumatal.length > 0) 
        {
            const FreeHangerProductId = 41038085324885;
              const updates = {
                [FreeHangerProductId]: 0 // 👈 fixed colon here
              };
              const updateResponse = await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates }),
              });
               const data = await updateResponse.json();
              // Refresh the cart drawer content
              $(".drawer").load(document.URL + " #CartDrawer");
        }
       else
        {
           $(".drawer").load(document.URL + " #CartDrawer");
          return { success: true, message: "No complete belts. Cart drawer refreshed." };
        }
     
    }

  const totalQuantity = completeBeltProducts.reduce(
    (sum, item) => sum + item.quantity,
    0
  );

  const FreeHangerProductId = 41038085324885;
  const updates = {
    [FreeHangerProductId]: totalQuantity > 3 ? 1 : 0,
  };

  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });

    const data = await response.json();

    $(".drawer").load(document.URL + " #CartDrawer");

    return {
      success: true,
      message: "Cart updated successfully with free hanger logic.",
      data,
    };
  } catch (error) {
    console.error("Error updating cart:", error);
    return {
      success: false,
      message: "Error updating cart.",
      error,
    };
  }
}




function upsellAddtoCart(id) {
  $("span#upsellButton").html("<b>Adding...</b>");
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: 32881698701397, // Replace with the product variant ID
      quantity: 1,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Product added:", data);
      $(".drawer").load(document.URL + " #CartDrawer");
    })
    .catch((error) => console.error("Error:", error));
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      //alert(this.dataset.randomstring)
      if (this.dataset.randomstring) 
      {
        cartItems.GetRandomStringValues(
          this.dataset.index,
          this.dataset.randomstring,
          0
        );
      } 
      else
      {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 400);
    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    //  alert(event.target.dataset.key);
    if (event.target.dataset.randomstring)
    {
      this.updateStringQuantity(event.target.dataset.index,event.target.dataset.randomstring,event.target.value,document.activeElement.getAttribute("name"),event.target.dataset.handle);
      //alert(document.activeElement.getAttribute('name'));
    }
    else {
      //alert(event.target.dataset.handle);
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.handle
      );
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }
  updateStringQuantity(
    line,
    randomString,
    quantity,
    tagetValue,
    productHandle
  ) {
    this.enableLoading(line);
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const randomStringToFind = randomString;
        // Filter items with matching randomString
        const matchingItems = cart.items.filter(
          (item) =>
            item.properties &&
            item.properties.randomString === randomStringToFind
        );
        // Extract variant IDs and quantities
        const result = matchingItems.map((item) => ({
          variant_id: item.variant_id,
          variant_handle: item.handle,
          item_key: item.key,
          quantity: item.quantity,
        }));
        console.log("Matching Cart Items:", result);
        this.updateCb(line, result, quantity, tagetValue, productHandle);
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }

  updateCb(line, result, qty, tagetValue, productHandle) {
    this.enableLoading(line);
    const updates = {};
    const boxSetItem = result.find(
      (item) =>
        item.variant_handle === "box-set" ||
        item.variant_handle === "women-box-set"
    );
    const addonItem = result.find(
      (item) =>
        item.variant_handle ===
        "add-on-premium-leather-strap-test-only-pls-not-buy"
    );
    // WHY totalQuantityboxSet BECAUSE WE ARE GETTING QTY ONLY FOR THOESE PRODUCT HAS RANDOM STRING AND THEY ARE BOX SET ANY
    //BOX SET MEN AND WOMEN ANY BOX SET WITH add-on-premium-leather-strap-test-only-pls-not-buy
    const totalQuantityboxSet = result.reduce(
      (sum, item) =>
        item.variant_handle !==
        "add-on-premium-leather-strap-test-only-pls-not-buy"
          ? sum + item.quantity
          : sum,
      0
    );
    const boxSetQuantity = totalQuantityboxSet;
    let addonItemsQuantity = addonItem ? addonItem.quantity : 0; // Make it mutable
    // only for plus newqty is used to chec addon value because if they are divived by 3 == 3 it mean we have to inscrease 3 every click and if there is 2 so it is increase by 2
    let Newqty = qty - 1;
    let NewqtyforMinus = parseInt(qty, 10) + 1;
    if (boxSetItem) {
      if (boxSetQuantity === addonItemsQuantity) {
        result.forEach((item) => {
          updates[item.item_key] = qty;
          updates[item.item_key] = qty;
        });
      }
      if (tagetValue === "plus") {
        if (addonItemsQuantity / Newqty === 3) {
          if (addonItem) {
            addonItemsQuantity += 3;
            updates[addonItem.item_key] = addonItemsQuantity;
            updates[boxSetItem.item_key] = qty;
          }
        } else if (addonItemsQuantity / Newqty === 2) {
          if (addonItem) {
            addonItemsQuantity += 2;
            updates[addonItem.item_key] = addonItemsQuantity;
            updates[boxSetItem.item_key] = qty;
          }
        }
      }
      if (tagetValue === "minus") {
        if (addonItemsQuantity / NewqtyforMinus === 3) {
          if (addonItem) {
            addonItemsQuantity -= 3;
            updates[addonItem.item_key] = addonItemsQuantity;
            updates[boxSetItem.item_key] = qty;
          }
        } else if (addonItemsQuantity / NewqtyforMinus === 2) {
          if (addonItem) {
            addonItemsQuantity -= 2;
            updates[addonItem.item_key] = addonItemsQuantity;
            updates[boxSetItem.item_key] = qty;
          }
        }
      }
    } else {
      result.forEach((item) => {
        updates[item.item_key] = qty; // Set correct quantity for each variant
      });
    }

       fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      })
        .then((response) => response.json()) // This already returns a JavaScript object
        .then((data) => {
          console.log("Cart Updated: women and men as well", data);
          console.log("Cart Updated: women and men as well", data.items); // Use 'data.items' directly
           newHangerAdded(data.items);
          // $(".drawer").load(document.URL + " #CartDrawer");
          // updateCartSection(); // Call function after cart update
        })
        .catch((error) => console.error("Error:", error));
  }

  updateQuantity(line, quantity, name, productHandle) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
              console.log(parsedState.items);
          newHangerAdded(parsedState.items);
         this.disableLoading();
        //$(".drawer").load(document.URL + " #CartDrawer");
      })
      .catch(() => {

        this.disableLoading();

        //  $(".drawer").load(document.URL + " #CartDrawer");
      });
  }

  
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      lineItemError.querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }

  GetRandomStringValues(line, randomString, quantity) {
    this.enableLoading(line);
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const randomStringToFind = randomString;
        // Filter items with matching randomString
        const matchingItems = cart.items.filter(
          (item) =>
            item.properties &&
            item.properties.randomString === randomStringToFind
        );
        // Extract variant IDs and quantities
        const result = matchingItems.map((item) => ({
          variant_id: item.variant_id,
          variant_handle: item.handle,
          item_key: item.key,
          quantity: item.quantity,
        }));
        this.removeALLRandomString(result);
        console.log("Matching Cart Items:", result);
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }

  removeALLRandomString(result) {
    let updates = {}; // Initialize updates object
    result.forEach((item) => {
      updates[item.item_key] = 0; // Set quantity to 0 for removal
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Cart Updated:", data);
        $("span#CartCount").text(data.item_count);
        // this.updateLiveRegions(line, data.item_count);
         newHangerAdded(data.items);
        // $(".drawer").load(document.URL + " #CartDrawer");
      })
      .catch((error) => console.error("Error:", error));
  }
}

customElements.define("cart-items", CartItems);
if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 400)
        );
      }
    }
  );
} 
